export default __webpack_public_path__ + "static/media/dubai.808b3c7b.jpg";